module.exports = __webpack_public_path__ + "img/award-logo__black-trophy.ea58373f.svg";